import { Dropdown } from "react-bootstrap";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import vconst from "utils/helpers/structs/vconst";
import SvgCornerUpLeft from "components/svg/SvgCornerUpLeft";
import SvgEye from "components/svg/SvgEye";
import useReversalProduct from "../../hooks/hookReversalProduct";
import { useObjectCard } from "../../context/ObjectCardProvider";
import * as apiObject from "api/apiObjects";
import { useToast } from "context/ToastContext";

const ExpendOtherActions = ({expend, setShowSpinnerExpend, setShowExpendInfo}) => {

    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { fetchObject, isEditLocked } = useObjectCard();
    const { reversalProduct } = useReversalProduct(); 
 
    const handleCancelExpendTeam = async () => {
        setShowSpinnerExpend(true);
        const resCanceled = await apiObject.cancelExpend(expend.ID);
        await fetchObject();
        setShowSpinnerExpend(false);

        if (resCanceled) showToast(t('messReversaled'), 'success')
                else showToast(t('common:messError'), 'danger')
    }

    const renderMenuItem = (icon, title, subtitle, onSelect, options) => (
        <Dropdown.Item
            as="button"
            disabled={options?.disabled}
            className={options?.danger ? 'text-danger' : undefined}
            onClick={(e) => {
                onSelect();
                e.currentTarget.blur();
            }}
        >
            <div className="d-flex align-items-start w-100 text-start">
                <span
                    className={`d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 item-icon${
                        options?.danger ? ' text-danger' : ''
                    }`}
                >
                    {icon}
                </span>
                <div className="flex-grow-1 min-w-0">
                    <div className={`fw-medium ${options?.danger ? 'text-danger' : ''}`}>{title}</div>
                    <small className="text-muted warehouse-team-menu-hint">{subtitle}</small>
                </div>
            </div>
        </Dropdown.Item>
    );

    const menu = (
        <Dropdown.Menu
            className="p-2 shadow-sm warehouse-team-menu"
            popperConfig={{ strategy: 'fixed' }}
            renderOnMount
        >
            {renderMenuItem(
                <SvgEye />,
                t('productPopup.info'),
                t('productPopup.infoHint'),
                () => setShowExpendInfo(expend.ID),
            )}

            <Dropdown.Divider className="my-2" />

            {renderMenuItem(
                <SvgCornerUpLeft />,
                t('productPopup.reversal'),
                t('productPopup.reversalHint'),
                () => reversalProduct(handleCancelExpendTeam, false),
                { disabled: expend.expendStatus !== vconst.incomeStatActive || isEditLocked },
            )}
        </Dropdown.Menu>
    );

    return (
        <Dropdown align="end">
            <Dropdown.Toggle className="p-1 py-0" 
                size="sm" 
                variant="light-secondary" 
                id="dropdown-basic">
                <i className="bi bi-three-dots"></i>
            </Dropdown.Toggle>

            {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
        </Dropdown>
    )
}

export default ExpendOtherActions;
